import { Button, Stack, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { PimDashboardState } from "context/PimDashboardContext";
import CostTable from "./CostTable/CostTable";
import { defaultTotalRow } from "./CostTable/data";
import {
	costingColumns,
	costingShootAssocObjKey,
	removeKeyFromArrOfObj,
	shootCostingItemsAssocObjKey,
	shootCostingUrlKey,
	totalCostColumn,
} from "./data";
import { useEffect, useState } from "react";
import { constraintsOptions, getColDefaultValue, isColumnDefault, selectedShootCostingPagepath } from "components/PimDashboard/data";
import { GlobalState } from "context/GlobalContext";
import { AuthState } from "context/AuthContext";
import { inputTypes, statusOptions } from "data/globalData";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";
import ShootSelection from "./ShootSelection/ShootSelection";
import { defaultTableData as costTableDefData } from "./CostTable/data";
import RenderAttributeInputs from "components/PimDashboard/CommonComponents/RenderAttributeInputs/RenderAttributeInputs";
import { attrValAssocObj } from "../../Designer/DesignerAttributes/data";

const CreateShootCosting = () => {
	const { allAttributesObj: styleAllAttributesObj } = PimDashboardState();
	const { snackBar, setLoadingOpen, setSnackBarOpen, setSnackBar } = GlobalState();
	const { user } = AuthState();
	const navigate = useNavigate();

	const [newCostingDetails, setNewCostingDetails] = useState({});
	const [selectedShoots, setSelectedShoots] = useState([]);
	const [optionDetailsColumns, setOptionDetailsColumns] = useState([]);

	const [costRows, setcostRows] = useState(costTableDefData);
	const [costTotalRow, setCostTotalRow] = useState(defaultTotalRow);
	useEffect(() => {
		if (!optionDetailsColumns?.length) {
			const columns = Object.values(costingColumns);
			setOptionDetailsColumns(columns);
			setNewCostingDetails(
				columns?.reduce((acc, row) => {
					acc[row?.key] = getColDefaultValue(row);
					return acc;
				}, {})
			);
		}
	}, []);

	const handleFormSubmit = async () => {
		setLoadingOpen(true);

		let pendingFields = [];
		Object.values(costingColumns)
			.filter((row) => row?.input_type !== inputTypes.AUTO_GENERATE.key)
			.forEach((attr) => {
				let obj = newCostingDetails;
				if (isColumnDefault(attr, obj?.[attr?.key]) && attr?.constraints[constraintsOptions.NOTNULL.key])
					pendingFields.push(attr);
			});
		if (pendingFields?.length) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: `Enter values for ${pendingFields.map((row) => row?.name)}`,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);

			return;
		}

		const sysData = {
			last_updated_by: user?.email,
			created_by: user?.email,
			status: statusOptions.CREATED.key,
		};

		try {
			const body = {
				...newCostingDetails,
				...sysData,
				[totalCostColumn?.key]: costTotalRow?.value,
				[shootCostingItemsAssocObjKey]: removeKeyFromArrOfObj(costRows, "id"),
				[costingShootAssocObjKey]: removeKeyFromArrOfObj(selectedShoots, "id"),
			};

			const { data } = await axios.post("/api/studio/create_shoot_costing", body);
			console.log("res.data", data);
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Costing Sheet created successfully",
				severity: "success",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			navigate(`/${selectedShootCostingPagepath}?${shootCostingUrlKey}=${data?.result?.shoot_costing_id}`);
			setLoadingOpen(false);
		} catch (error) {
			console.log(error, "ddsfdghjkl");
			setLoadingOpen(false);
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, severity: "error", message: parseErrorMessage(error) });
		}
	};

	return (
		<Stack spacing={2} pt={2} pb={10}>
			{/* <Divider /> */}

			<ShootSelection
				selectedShoots={selectedShoots}
				setSelectedShoots={setSelectedShoots}
				costingDetails={newCostingDetails}
				disabled={false}
				height={250}
			/>

			<Box sx={{ minWidth: "50%" }} flexGrow={1} pt={2}>
				{/* <Typography variant="h6">Option Details</Typography> */}
				<RenderAttributeInputs
					columns={optionDetailsColumns}
					setData={setNewCostingDetails}
					data={newCostingDetails}
					selectOptObjOptName={attrValAssocObj}
					inputWidth="30%"
				/>
			</Box>
			<CostTable rows={costRows} setRows={setcostRows} totalRow={costTotalRow} setTotalRow={setCostTotalRow} mode="create" />

			<Button
				sx={{ position: "fixed", left: "50%", bottom: "10px", transform: "translate(-50%,0%)" }}
				size="large"
				variant="contained"
				onClick={handleFormSubmit}>
				Create and Save
			</Button>
		</Stack>
	);
};

export default CreateShootCosting;
